module.exports = __webpack_public_path__ + "img/suppliers.d55cb57a.jpg";